/**
 * 
 * @param {*} formData 
 * @returns 
 */

function generateRenderedForm(formData, ispro, theme = 'theme-0') {
  let html = '';
  let currentPage = 1;
  let totalPages = 1;
  let isPageStarted = false;
  let hasSubmitButton = false;

  // Add theme class to the main container
  html += `
    <style>
      .simple_form_content {
        font-family: 'Arial', sans-serif;
      }
      
      .simple_form_content .page {
        display: none;
      }
      
      .simple_form_content .page.active {
        display: block;
      }
      
      /* Navigation container */
      .navigation-buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        padding: 10px 0;
      }
      
      .navigation-buttons.first-page {
        justify-content: flex-end;
      }
      
      .navigation-buttons.with-submit {
        justify-content: space-between;
      }
      
      /* Button styles - basic shared styles */
      .simple_form_content .form-btn {
        border: none;
        border-radius: 5px;
        padding: 7px 20px;
        cursor: pointer;
        font-size: 16px;
        height: 38px;
        margin-right: 10px;
      }
      
      .simple_form_content .next-btn,
      .simple_form_content .prev-btn,
      .simple_form_content .submit-btn {
        background-color: #a177f8;
        color: #fff;
      }
      
      /* Responsive design */
      @media (max-width: 768px) {
        .form-row.horizontal {
          flex-direction: column;
        }
        
        .navigation-buttons {
          flex-direction: row;
          justify-content: center;
        }
        
        .simple_form_content .form-btn {
          margin: 5px;
        }
      }
      
      /* Signature panel styles */
      .signature-panel {
        border: 1px solid gray;
        padding: 5px;
        width: 100%;
        max-width: 300px;
      }
      
      /* Row layout styles */
      .form-row {
        display: flex;
        margin-bottom: 15px;
      }
      
      .form-row.horizontal {
        flex-direction: row;
        gap: 15px;
      }
      
      .form-row.vertical {
        flex-direction: column;
        gap: 10px;
      }
      
      /* Field styles */
      .text-fields {
        margin-bottom: 15px;
        width: 100%;
      }
      
      .text-fields input:not([type="checkbox"]):not([type="radio"]),
      .text-fields select,
      .text-fields textarea {
        width: 100%;
        padding: 8px;
        border: 1px solid #ddd;
        border-radius: 4px;
        box-sizing: border-box;
        margin-top: 5px;
      }
      
      .text-fields label {
        display: block;
        margin-bottom: 5px;
        font-weight: 500;
      }

      /* Required field indicator styles */
      .required-indicator {
        color: #e32;
        margin-left: 3px;
        font-weight: bold;
      }
      
      /* Add tooltip for required fields */
      .required-field-label {
        position: relative;
      }
      
      .required-indicator:hover::after {
        content: 'This field is required';
        position: absolute;
        background: rgba(0, 0, 0, 0.7);
        color: white;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 12px;
        white-space: nowrap;
        z-index: 99;
        left: 0;
        top: 100%;
        margin-top: 5px;
      }


    </style>
  `;

  // Add theme-specific styles
  html += getThemeStyles(theme); // No need now

  // Start the form container with the selected theme
  html += `<div class="simple_form_content ${theme}">`;
  
  // Start with the first page
  html += `<div class="page" data-page="${currentPage}">`;
  isPageStarted = true;

  // Process the form data
  processFormData(formData);

  // Close the last page if it's still open
  if (isPageStarted) {
    // Check for submit button in the last page
    const hasSubmitOnLastPage = checkForSubmitButton(formData);
    
    // Add navigation for the last page
    if (hasSubmitOnLastPage) {
      if (currentPage > 1) {
        html += `<div class="navigation-buttons with-submit">
                  <button type="button" class="form-btn prev-btn" data-page="${currentPage - 1}">Previous</button>
                </div>`;
      }
    } else {
      if (currentPage > 1) {
        html += `<div class="navigation-buttons">
                  <button type="button" class="form-btn prev-btn" data-page="${currentPage - 1}">Previous</button>
                </div>`;
      }
    }
    
    html += `</div>`;
  }

  // Close the form container
  html += `</div>`;

  return html;

  // Function to check if the form data contains a submit button
  function checkForSubmitButton(data) {
    for (const item of data) {
      if (item.type === 'submit') {
        return true;
      }
      
      if (item.type === 'row' && item.fields) {
        for (const field of item.fields) {
          if (field.type === 'submit') {
            return true;
          }
        }
      }
    }
    return false;
  }

  // Function to process the entire form data array
  function processFormData(data) {
    let submitButtonFound = false;
    
    data.forEach((item) => {
      if (item.type === 'row') {
        processRow(item);
      } else if (item.type === 'submit') {
        submitButtonFound = true;
        processField(item);
      } else {
        // If it's a direct field (not in a row)
        processField(item);
      }
    });
    
    hasSubmitButton = submitButtonFound;
  }

  // Function to process a row and its fields
  function processRow(row) {
    let currentRowHtml = ''; // Collect HTML for this row
    let rowStarted = false;
    let pageBreakInRow = false;
    let submitButtonInRow = false;
    
    // First pass to check if there's a submit button in this row
    for (let i = 0; i < row.fields.length; i++) {
      if (row.fields[i].type === 'submit') {
        submitButtonInRow = true;
        break;
      }
    }
    
    // Process fields in this row
    for (let i = 0; i < row.fields.length; i++) {
      const field = row.fields[i];
      
      // If we encounter a page break
      if (field.type === 'page_break') {
        pageBreakInRow = true;
        
        // If we've already started the row, close it
        if (rowStarted) {
          currentRowHtml += `</div>`;
          rowStarted = false;
          
          // Add the row's HTML so far to the current page
          html += currentRowHtml;
          currentRowHtml = '';
        }
        
        // Add navigation buttons and close current page
        if (isPageStarted) {
          // Add next/prev buttons for the current page
          if (currentPage === 1) {
            html += `<div class="navigation-buttons first-page">
                      <button type="button" class="form-btn next-btn" data-page="${currentPage + 1}">Next</button>
                    </div>`;
          } else {
            html += `<div class="navigation-buttons">
                      <button type="button" class="form-btn prev-btn" data-page="${currentPage - 1}">Previous</button>
                      <button type="button" class="form-btn next-btn" data-page="${currentPage + 1}">Next</button>
                    </div>`;
          }
          
          html += `</div>`;
          isPageStarted = false;
        }
        
        // Increment page counter
        totalPages++;
        currentPage++;
        
        // Start a new page
        html += `<div class="page" data-page="${currentPage}">`;
        isPageStarted = true;
        
        continue; // Skip further processing for this field
      }
      
      // If this is the first field after a page break or the first field in the row
      if (!rowStarted) {
        currentRowHtml += `<div class="form-row ${row.layout}" id="${row.id}">`;
        rowStarted = true;
      }
      
      // Add the field to the current row HTML
      currentRowHtml += renderField(field);
    }
    
    // If we have a row that's still open, close it
    if (rowStarted) {
      currentRowHtml += `</div>`;
    }
    
    // Add any remaining row HTML to the current page
    html += currentRowHtml;
  }

  // Function to process a standalone field (not in a row)
  function processField(field) {
    if (field.type === 'page_break') {
      // Close the current page
      if (isPageStarted) {
        // Add next/prev buttons for the current page
        if (currentPage === 1) {
          html += `<div class="navigation-buttons first-page">
                    <button type="button" class="form-btn next-btn" data-page="${currentPage + 1}">Next</button>
                  </div>`;
        } else {
          html += `<div class="navigation-buttons">
                    <button type="button" class="form-btn prev-btn" data-page="${currentPage - 1}">Previous</button>
                    <button type="button" class="form-btn next-btn" data-page="${currentPage + 1}">Next</button>
                  </div>`;
        }
        
        html += `</div>`;
        isPageStarted = false;
      }
      
      // Increment page counter
      totalPages++;
      currentPage++;
      
      // Start a new page
      html += `<div class="page" data-page="${currentPage}">`;
      isPageStarted = true;
    } else {
      // Render any other type of field
      html += renderField(field);
    }
  }

  // Helper function to create label with required indicator if needed
  function getLabel(field) {
    const isRequired = field.required === true || field.required === "true";
    let labelClass = isRequired ? 'required-field-label' : '';
    let requiredIndicator = isRequired ? '<span class="required-indicator">*</span>' : '';
    
    return `<label for="${field.id}" class="${labelClass}">${field.label}${requiredIndicator}</label>`;
  }

  // Function to render a single field based on its type
  function renderField(field) {
    let fieldHtml = '';
    let fieldAttributes = '';
    
    if (field.required === true || field.required === "true") {
      fieldAttributes += ' required';
    }

    switch (field.type) {
      case 'image':
        fieldHtml += `
          <div class="text-fields">
            <label for="${field.id}">${field.label}</label>
            <div class="${field.className}">
              <img src="${field.src}" width="${field.width}" height="${field.height}" alt="${field.label}">
            </div>
          </div>
        `;
        break;

      case 'hidden':
        fieldHtml += `
            <input id="${field.id}" type="${field.type}" name="${field.name}" placeholder="${field.placeholder}" class="${field.className}" value="${field.value || ''}"${fieldAttributes}>
        `;
        break;

      case 'textarea':
        fieldHtml += `
          <div class="text-fields">
           ${getLabel(field)}
            <textarea id="${field.id}" name="${field.name}" placeholder="${field.placeholder || ''}" class="${field.className}"${fieldAttributes}>${field.value || ''}</textarea>
          </div>
        `;
        break;

      case 'file':
        fieldHtml += `
          <div class="text-fields">
           ${getLabel(field)}
            <input id="${field.id}" type="${field.type}" name="${field.name}" class="${field.className}"${fieldAttributes}>
          </div>
        `;
        break;

      case 'heading':
          fieldHtml += `
            <div class="text-fields">
              <${field.headingtype} class="${field.className}">${field.content}</${field.headingtype}>
            </div>
          `;
        break;
        
      case 'label':
            fieldHtml += `
              <div class="text-fields">
                <label for="${field.id}" class="${field.className}">${field.content}</label>
              </div>
            `;
        break;
      case 'link':
            fieldHtml += `
              <div class="simple-form-file">
                ${getLabel(field)}
                <a id="${field.id}" href="${field.href}" target="${field.target}" class="${field.className}">${field.content}</a>
              </div>
            `;
        break;
      case 'video':
            fieldHtml += `
              <div class="text-fields">
                <video
                  id="${field.id}"
                  width="${field.width}"
                  height="${field.height}"
                  controls
                  src="${field.src}"
                  class="${field.className}"
                >
                  ${field.content}
                </video>
              </div>
            `;
        break;
      case 'audio':
            fieldHtml += `
              <div class="text-fields">
                <audio
                  id="${field.id}"
                  width="${field.width}"
                  height="${field.height}"
                  controls
                  src="${field.src}"
                  class="${field.className}"
                >
                  ${field.content}
                </audio>
              </div>
            `;
        break;

      case 'iframe':
            fieldHtml += `
              <div class="text-fields">
                <iframe
                  id="${field.id}"
                  width="${field.width}"
                  height="${field.height}"
                  src="${field.src}"
                  class="${field.className}"
                >
                  ${field.content}
                </iframe>
              </div>
            `;
        break;

      case 'esignature':
        fieldHtml += `
          <div class="text-fields">
            ${getLabel(field)}
            <div class="signature-panel">
              <canvas id="${field.id}" class="signature-canvas" width="300" height="150"></canvas>
              <input type="hidden" name="${field.name}" class="signature-data" data-canvas-id="${field.id}">
              <button type="button" class="reset-signature form-btn" data-canvas-id="${field.id}">Reset Signature</button>
            </div>
          </div>
        `;
        break;

      // Never change the class name from editor sf-turnstile-container 
      case 'cloudflare': 
        fieldHtml += `
          <div class="text-fields">
              <div class="${field.className}" id="${field.id}" data-sitekey="${field.sitekey}" data-theme="${field.theme}"   data-submit-button="${field.btnaccess}" data-size="${field.size}" data-error="${field.error}">
              </div>
          </div>
        `;
        break;

      case 'customcaptcha':
        // Generate two random values and an operator
        const value1 = Math.floor(Math.random() * 10) + 1;
        const value2 = Math.floor(Math.random() * 10) + 1;
        const operators = ['+', '-', '*'];
        const operator = operators[Math.floor(Math.random() * operators.length)];
      
        // Calculate the correct answer
        let correctAnswer;
        switch (operator) {
          case '+': correctAnswer = value1 + value2; break;
          case '-': correctAnswer = value1 - value2; break;
          case '*': correctAnswer = value1 * value2; break;
          default: break;
        }
      
        fieldHtml += `
          <div class="text-fields">
            ${getLabel(field)}
            <div>
              <span class="question-${field.className}">${value1} ${operator} ${value2} = </span>
              <input id="${field.id}" type="text" name="${field.name}" placeholder="Your Answer" class="${field.className}" required>
              <input type="hidden" name="${field.name}_correct" value="${correctAnswer}">
            </div>
          </div>
        `;
        break;

      case 'checkbox':
        const isRequired = field.required === true || field.required === "true";
        let requiredIndicator = isRequired ? '<span class="required-indicator">*</span>' : '';

        if (field.toggle === 'true') {
          // Render toggle checkbox
          fieldHtml += `
            <div class="simple-form-checkbox-toggle">
              <label class="switch-label ${isRequired ? 'required-field-label' : ''}">${field.label}${requiredIndicator}
                <input type="checkbox" id="${field.id}" name="${field.name}" class="switch-input ${field.className}"${fieldAttributes}>
                <span class="slider round"></span>
              </label>
            </div>`;
        } else {
          // Render standard checkboxes
          fieldHtml += `
            <div class="text-fields">
              <label class="${isRequired ? 'required-field-label' : ''}">${field.label}${requiredIndicator}</label>`;
          field.options.forEach((option) => {
            fieldHtml += `
              <div class="text-fields-insider">
                <input type="checkbox" id="${option.value}" name="${field.name}" value="${option.value}"${fieldAttributes}>
                <label for="${option.value}">${option.label}</label>
              </div>`;
          });
          fieldHtml += `
            </div>`;
        }
        break;
    
      case 'radio':
        const radioIsRequired = field.required === true || field.required === "true";
        let radioRequiredIndicator = radioIsRequired ? '<span class="required-indicator">*</span>' : '';

        fieldHtml += `
          <div class="text-fields">
            <label class="${radioIsRequired ? 'required-field-label' : ''}">${field.label}${radioRequiredIndicator}</label>`;
        field.options.forEach((option) => {
          fieldHtml += `
            <div class="text-fields-insider">
              <input
                type="radio"
                id="${option.value}"
                name="${field.name}"
                value="${option.value}"
                ${field.value === option.value ? 'checked' : ''}
                ${fieldAttributes}
              />
              <label for="${option.value}">${option.label}</label>
            </div>`;
        });
        fieldHtml += `
          </div>`;
        break;

      case 'select':
        fieldHtml += `
          <div class="text-fields">
            ${getLabel(field)}
            <select id="${field.id}" name="${field.name}"${fieldAttributes}>`;
        field.options.forEach((option) => {
          fieldHtml += `
            <option value="${option.value}" ${field.value === option.value ? 'selected' : ''}>${option.label}</option>
          `;
        });
        fieldHtml += `
            </select>
          </div>
        `;
        break;

      case 'submit':
        fieldHtml += `
          <div class="text-fields">
            <input id="${field.id}" type="${field.type}" name="${field.name}" class="form-btn submit-btn ${field.className}" value="${field.value || 'Submit'}"${fieldAttributes}>
          </div>
        `;
        hasSubmitButton = true;
        break;

      case 'number':
        fieldHtml += `
          <div class="text-fields">
           ${getLabel(field)}
            <input id="${field.id}" type="${field.type}" name="${field.name}" min="${field.min}" max="${field.max}"  placeholder="${field.placeholder || ''}" class="${field.className}" value="${field.value || ''}"${fieldAttributes}>
          </div>
        `;
        break;

      // Handle standard input types
      case 'text':
      case 'number':
      case 'email':
      case 'button':
      case 'color':
      case 'date':
      case 'datetime-local':
      case 'month':
      case 'password':
      case 'range':
      case 'reset':
      case 'search':
      case 'tel':
      case 'time':
      case 'url':
        fieldHtml += `
          <div class="text-fields">
            ${getLabel(field)}
            <input id="${field.id}" type="${field.type}" name="${field.name}" placeholder="${field.placeholder || ''}" class="${field.className}" value="${field.value || ''}"${fieldAttributes}>
          </div>
        `;
        break;

      default:
        break;
    }

    return fieldHtml;
  }
  
  // Function to get theme-specific styles - mainly its used here but maxium style maintain from frontend.scss 
  function getThemeStyles(theme) {
    switch (theme) {
      case 'theme-1':
        return `
          <style>
            .simple_form_content.theme-1 {
              background-color: #ffffff;
              color: #333333;
            }
          </style>
        `;
        
      case 'theme-2':
        return `
          <style>
            .simple_form_content.theme-2 {
              background-color: #f8f9fa;
              color: #212529;
              padding: 25px;
              border-radius: 12px;
              box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
              border: 1px solid #e9ecef;
            }
          </style>
        `;
      case 'theme-3':
        return `
          <style>
            .simple_form_content.theme-3 {
              background-color:#2c3e50;
              color: #ecf0f1;
              padding: 30px;
              border-radius: 8px;
              box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
            }
          </style>
        `;
      case 'theme-4':
        return `
          <style>
            .simple_form_content.theme-4 {
              background-color: #f5f6fa;
              color: #2c3e50;
              padding: 30px;
              border-radius: 12px;
              box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
            }
          </style>
        `;
      case 'theme-5':
        return `
          <style>
            .simple_form_content.theme-5 {
              background-color: #1e1e2f;
              color: #ecf0f1;
               padding: 30px;
              border-radius: 12px;
              box-shadow: 0 5px 25px rgba(0, 0, 0, 0.3);
            }
          </style>
        `;
      case 'theme-6':
        return `
          <style>
            .simple_form_content.theme-6 {
              background-color: #e6eef9;
              color: #2d3436;
              border-radius: 12px;
              font-weight: 600;
              border: none;
              padding: 12px 24px;
              box-shadow: 5px 5px 10px rgba(166, 180, 200, 0.3),
                -5px -5px 10px rgba(255, 255, 255, 0.8);
              transition: all 0.3s ease;
            }
          </style>
        `;
      case 'theme-7':
        return `
          <style>
            .simple_form_content.theme-7 {
              background-color: #121212;
              color: #ffffff;
              padding: 30px;
              border-radius: 16px;
              backdrop-filter: blur(10px);
              box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
              border: 1px solid rgba(255, 255, 255, 0.05);
            }
          </style>
        `;
      
      default:
        return '';
    }
  }
}



  /**
   * Load Form and new page break add.
   * Load Form with page break
   */

  document.addEventListener('DOMContentLoaded', function () {
    var formContainers = document.querySelectorAll('.simple_form_container');

    formContainers.forEach(function (container) {
        var formId = container.getAttribute('data-form-id');
        var formTheme = container.getAttribute('data-form-theme');
        var formPosition = container.getAttribute('data-position') || 'inline';
        // console.log(formTheme)
        var nonce = container.getAttribute('data-nonce');
        var cf7 = container.getAttribute('data-cf7');
        // var markupId = container.querySelector('.simple_form_loader').id;
        var markupId = '';
        var simpleFormLoader = container.querySelector('.simple_form_loader');
        if (simpleFormLoader) {
          var markupId = simpleFormLoader.id;
        }

        var isFloatingForm = formPosition !== 'inline';

        var submitBtn = container.querySelector('.submit-button');

        var isThemeActiveInForm = container.querySelector('.floating-form-container') !== null;
        // console.log(isThemeActiveInForm);

        var theme = isThemeActiveInForm ? 'theme-off' : formTheme;  // 1 to 7
        // var theme = isThemeActiveInForm ? 'theme-off' : 'theme-7';  // 1 to 7

        if (isFloatingForm) {
          var toggleBtn = container.querySelector('.simple_form_toggle');
          var floatingContainer = container.querySelector('.simple_form_floating_container');
          var closeBtn = container.querySelector('.simple_form_close');
          var expandBtn = container.querySelector('.simple_form_expand_btn');
          var isExpanded = false;
          
          if (toggleBtn && floatingContainer) {
              toggleBtn.addEventListener('click', function() {
                  // First set display to block (but still invisible due to opacity: 0)
                  floatingContainer.style.display = 'block';

                   toggleBtn.style.display = 'none';
                  
                  // Force a reflow to ensure the display change takes effect before adding the visible class
                  void floatingContainer.offsetWidth;
                  
                  // Then add the visible class to trigger the transition
                  setTimeout(function() {
                      floatingContainer.classList.add('visible');
                  }, 10);
              });
          }
          
          if (closeBtn && floatingContainer) {
              closeBtn.addEventListener('click', function() {
                  // First remove the visible class to trigger the fade out
                  floatingContainer.classList.remove('visible');
                  
                  // Then hide after transition completes
                  setTimeout(function() {
                      floatingContainer.style.display = 'none';
                      toggleBtn.style.display = 'flex';
                  }, 300); // Match the CSS transition duration
              });
          }
          
          if (expandBtn && floatingContainer) {
              // Set the initial expand icon
              expandBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6"></path><path d="M9 21H3v-6"></path><path d="M21 3l-7 7"></path><path d="M3 21l7-7"></path></svg>';
              
              expandBtn.addEventListener('click', function() {
                  isExpanded = !isExpanded;
                  
                  if (isExpanded) {
                      // Expand the form
                      floatingContainer.classList.add('expanded');
                      // Change to minimize icon
                      expandBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3v3a2 2 0 0 1-2 2H3"></path><path d="M21 8h-3a2 2 0 0 1-2-2V3"></path><path d="M3 16h3a2 2 0 0 1 2 2v3"></path><path d="M16 21v-3a2 2 0 0 1 2-2h3"></path></svg>';
                  } else {
                      // Restore original size
                      floatingContainer.classList.remove('expanded');
                      // Restore the expand icon
                      expandBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6"></path><path d="M9 21H3v-6"></path><path d="M21 3l-7 7"></path><path d="M3 21l7-7"></path></svg>';
                  }
              });
          }
        }
        

        fetch(front_end_data.admin_ajax + '?action=simpleform_table_html&nonce=' + nonce + '&id=' + formId + '&iscf7=' + cf7)
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(function (data) {
                // console.log(data.data.cf7_render)
                if(cf7 === 'false'){
                  const code = document.getElementById(markupId);
                  const formData = data.data.table_settings;
                  const isPro = front_end_data.isProActive; 
                  const renderedFormHTML = generateRenderedForm(formData, isPro, theme);
                  code.innerHTML = renderedFormHTML;

                 /**
                 * Initilize all required function for fields 
                 */

                  //Signature 
                  canvasSignature(code);

                  // Set up reset button click handlers
                  setupResetButtons(code);

                  // Initialize the form slider : Keep it below of all 
                  initializeFormSlider(code, submitBtn);

                }
                // No need to render through JS as direct shortcode used to render 
                /* else{
                  const code = document.getElementById(markupId);
                  const formData = data.data.cf7_render;
                  code.innerHTML = formData;
                } */

            })
            .catch(function (error) {
                // console.log('SForm', formId, 'Error:', error.message);
            });
    });
  });



  // Animention task ------------

  // Function to apply attention-grabbing animation
  function applyAttentionAnimation(toggleBtn) {
    // Add animation class
    toggleBtn.classList.add('simple_form_attention');
    
    // Remove animation class after animation completes
    setTimeout(() => {
      toggleBtn.classList.remove('simple_form_attention');
    }, 2000); // Animation duration + a bit extra
  }

  // Function to apply spinning animation on click
  function applySpinAnimation(toggleBtn) {
    toggleBtn.classList.add('simple_form_spin');
  }

  // Add the animation logic to your existing code
  document.addEventListener('DOMContentLoaded', function() {
    var formContainers = document.querySelectorAll('.simple_form_container');

    formContainers.forEach(function(container) {
      var formPosition = container.getAttribute('data-position') || 'inline';
      var isFloatingForm = formPosition !== 'inline';
      
      if (isFloatingForm) {
        var toggleBtn = container.querySelector('.simple_form_toggle');
        var floatingContainer = container.querySelector('.simple_form_floating_container');
        
        if (toggleBtn && floatingContainer) {
          // Set up attention animation interval
          setInterval(function() {
            applyAttentionAnimation(toggleBtn);
          }, 10000); // Run every 10 seconds
          
          // Run it once after 3 seconds on page load
          setTimeout(function() {
            applyAttentionAnimation(toggleBtn);
          }, 3000);
          
          // Add click handler with spinning animation
          toggleBtn.addEventListener('click', function() {
            // Add spinning animation
            applySpinAnimation(toggleBtn);
            
            // First set display to block
            floatingContainer.style.display = 'block';
            
            // Force a reflow
            void floatingContainer.offsetWidth;
            
            // Add visible class to trigger transition
            setTimeout(function() {
              floatingContainer.classList.add('visible');
              
              // Remove spinning animation once form is visible
              setTimeout(function() {
                toggleBtn.classList.remove('simple_form_spin');
              }, 500);
            }, 10);
          });
        }
      }
    });
  });

  // Animention task Emd


/**
 * Signature 
 */

function canvasSignature(formContainer) {
  var pages = formContainer.querySelectorAll('.page');

  pages.forEach(function (page) {
    const signatureCanvases = page.querySelectorAll('.signature-canvas');
    signatureCanvases.forEach(function (canvas) {
      const context = canvas.getContext('2d');
      let isDrawing = false;

      // Handle mouse events
      canvas.addEventListener('mousedown', function (e) {
        isDrawing = true;
        drawStart(e, context);
      });

      canvas.addEventListener('mousemove', function (e) {
        if (isDrawing) {
          draw(e, context);
        }
      });

      canvas.addEventListener('mouseup', function () {
        if (isDrawing) {
          isDrawing = false;
          drawEnd(context);
        }
      });

      canvas.addEventListener('mouseout', function () {
        if (isDrawing) {
          isDrawing = false;
          drawEnd(context);
        }
      });

      // Handle touch events
      canvas.addEventListener('touchstart', function (e) {
        e.preventDefault();
        isDrawing = true;
        const touch = e.touches[0];
        const simulatedEvent = new MouseEvent('mousedown', {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        canvas.dispatchEvent(simulatedEvent);
      });

      canvas.addEventListener('touchmove', function (e) {
        e.preventDefault();
        if (isDrawing) {
          const touch = e.touches[0];
          const simulatedEvent = new MouseEvent('mousemove', {
            clientX: touch.clientX,
            clientY: touch.clientY
          });
          canvas.dispatchEvent(simulatedEvent);
        }
      });

      canvas.addEventListener('touchend', function () {
        e.preventDefault();
        if (isDrawing) {
          isDrawing = false;
          drawEnd(context);
        }
      });

      canvas.addEventListener('touchcancel', function () {
        e.preventDefault();
        if (isDrawing) {
          isDrawing = false;
          drawEnd(context);
        }
      });
    });
  });
}


function drawStart(e, context) {
  context.beginPath();
  draw(e, context);
}

function drawEnd(context) {
  context.closePath();
}

function draw(e, context) {
  const rect = e.target.getBoundingClientRect();
  const mouseX = e.clientX - rect.left;
  const mouseY = e.clientY - rect.top;

  context.lineWidth = 2;
  context.lineCap = 'round';

  context.lineTo(mouseX, mouseY);
  context.stroke();
  context.moveTo(mouseX, mouseY);
}


/**
 * 
 * Reset Canvas
 */

function setupResetButtons(formContainer) {
  const resetButtons = formContainer.querySelectorAll('.reset-signature');
  // console.log(resetButtons)
  resetButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      const canvasId = button.getAttribute('data-canvas-id');
      resetSignatureCanvas(canvasId);
    });
  });
}

function resetSignatureCanvas(canvasId) {

  const canvas = document.getElementById(canvasId);
  const context = canvas.getContext('2d');
  
  // Clear the canvas
  context.clearRect(0, 0, canvas.width, canvas.height);

  // Additional code for resetting any other related state or variables
}

/**
 * 
 Slider form for next and prev page
 */
function initializeFormSlider(formContainer, submitBtn) {

  var pages = formContainer.querySelectorAll('.page');
  var currentPage = 1;

  // console.log(formContainer)
  // console.log("initializeFormSlider is running!");

  function showPage(pageNumber) {
      pages.forEach(function (page) {
          page.style.display = 'none';
      });

      var currentPageElement = formContainer.querySelector('.page[data-page="' + pageNumber + '"]');
      if (currentPageElement) {
          currentPageElement.style.display = 'block';
      }

      // Toggle the visibility of the submit button based on the presence of the next button.
      var isNext = currentPageElement.querySelector('.next-btn') !== null;
    
      if (submitBtn) {
        // submitBtn.style.display = isNext ? 'none' : 'inline-block';
        submitBtn.style.display = isNext ? 'none' : 'flex';
      }else{
        console.log("Button not found")
      }
  }

  /**
   * Page next and prev button visibility
   */
  function updateButtonsVisibility() {
      var prevButton = formContainer.querySelector('.prev-btn');
      var nextButton = formContainer.querySelector('.next-btn');

      if (currentPage === 1) {
          prevButton.style.display = 'none';
      } else {
          prevButton.style.display = 'inline-block';
      }

      if (currentPage === pages.length) {
          nextButton.style.display = 'none';
      } else {
          nextButton.style.display = 'inline-block';
      }
  }

  // Initial setup
  showPage(currentPage);
  updateButtonsVisibility();

  // Event listeners for next and previous buttons
  formContainer.addEventListener('click', function (event) {
      var target = event.target;

      if (target.classList.contains('next-btn')) {
        // Do not proceed if required fields are not filled
        if (!validateRequiredFields(currentPage)) {
            return;
        }
        //IF all ok move next 
        currentPage++;

      } else if (target.classList.contains('prev-btn')) {
          currentPage--;
      }
      showPage(currentPage);
      updateButtonsVisibility();
  });


  /**
   * Validation of next button move
   */
    function validateRequiredFields(pageNumber) {
      var currentPageElement = formContainer.querySelector('.page[data-page="' + pageNumber + '"]');
      var requiredFields = currentPageElement.querySelectorAll('[required]');
      var isValid = true;
  
      requiredFields.forEach(function (field) {
          if (field.value.trim() === '') {
              field.style.border = '1px solid red';
              isValid = false;
          } else {
              field.style.border = '';
          }
      });
  
      var errorMessage = currentPageElement.querySelector('.blank-filled-error-message');
  
      if (!isValid) {
          // Display an error message below the "text-fields" div
          if (!errorMessage) {
              errorMessage = document.createElement('div');
              errorMessage.className = 'blank-filled-error-message';
              errorMessage.style.color = 'red';
              errorMessage.textContent = 'Please fill out all required fields.';
              currentPageElement.querySelector('.text-fields').appendChild(errorMessage);
          }
      } else {
          // Remove the error message if fields are valid
          if (errorMessage) {
              errorMessage.remove();
          }
      }
  
      return isValid;
  }

}

// Modal --------------------
// Custom modal implementation to replace SweetAlert
// Add this to your existing JavaScript file

function showCustomModal(title, message, duration = 3000) {
  // Create modal container
  const modalOverlay = document.createElement('div');
  modalOverlay.className = 'custom-modal-overlay';
  
  // Create modal content
  const modalContent = document.createElement('div');
  modalContent.className = 'custom-modal';
  
  // Create header with title
  const modalHeader = document.createElement('div');
  modalHeader.className = 'custom-modal-header';
  
  const modalTitle = document.createElement('h3');
  modalTitle.textContent = title;
  modalHeader.appendChild(modalTitle);
  
  // Create message content
  const modalBody = document.createElement('div');
  modalBody.className = 'custom-modal-body';
  modalBody.innerHTML = message;
  
  // Create progress bar
  const progressBar = document.createElement('div');
  progressBar.className = 'custom-modal-progress';
  
  const progressIndicator = document.createElement('div');
  progressIndicator.className = 'custom-modal-progress-indicator';
  progressBar.appendChild(progressIndicator);
  
  // Assemble the modal
  modalContent.appendChild(modalHeader);
  modalContent.appendChild(modalBody);
  modalContent.appendChild(progressBar);
  modalOverlay.appendChild(modalContent);
  
  // Add to document
  document.body.appendChild(modalOverlay);
  
  // Show modal with animation
  setTimeout(() => {
    modalOverlay.classList.add('visible');
    progressIndicator.style.transition = `width ${duration}ms linear`;
    progressIndicator.style.width = '100%';
  }, 10);
  
  // Auto close after duration
  setTimeout(() => {
    modalOverlay.classList.remove('visible');
    setTimeout(() => {
      document.body.removeChild(modalOverlay);
    }, 300); // Wait for fade out animation
  }, duration);
  
  // Allow clicking outside to close
  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) {
      modalOverlay.classList.remove('visible');
      setTimeout(() => {
        document.body.removeChild(modalOverlay);
      }, 300);
    }
  });
}


/**
 * Submit Form data get and store in DB and other form submission task here
 */

window.addEventListener('load', function () {
  var formContainers = document.querySelectorAll('.simple_form_container');
  const formContent = document.querySelector('.form-content');

  formContainers.forEach(function (formContainer) {
    var formId = formContainer.dataset.formId;
    var nonce = formContainer.dataset.nonce;

    // Find the submit button within the current form container
    var submitButton = formContainer.querySelector('.submit-button');


    if(!submitButton){
      return; 
    }


    // Store the original button text
    var originalButtonText = submitButton.innerText;

    // Create a div for displaying error messages
    var errorDiv = document.createElement('div');
    errorDiv.className = 'error-message';
    errorDiv.style.color = 'red';
    formContainer.appendChild(errorDiv);
    

    submitButton.addEventListener('click', function (event) {

      // Prevent the default form submission behavior
      event.preventDefault();

      // Change button text to "Sending..."
      submitButton.innerText = 'Sending...';

      // Get all form elements within the form
      var formElements = formContainer.querySelectorAll('input, select, textarea');

      // Create an object to store the form data
      var formDataObject = {};

      // Create a flag to track if there are any required fields that are empty
      var hasEmptyRequiredFields = false;
      var errorMessage = '';

      formElements.forEach(function (element) {
          // Check if the element has the "simple-form-checkbox-toggle" class
          var isToggleCheckbox = element.closest('.simple-form-checkbox-toggle') !== null;

          // Handle checkboxes with the "simple-form-checkbox-toggle" class
          if (isToggleCheckbox && element.type === 'checkbox') {
            formDataObject[element.name] = element.checked ? 'on' : 'off';
          } else {
            formDataObject[element.name] = element.value;
          }

          // Check if the field is required and empty
          if (element.hasAttribute('required') && formDataObject[element.name].trim() === '') {
            // Add a red border to indicate the required field is empty
            element.style.border = '1px solid red';
            hasEmptyRequiredFields = true;
          } else {
            // Remove any red border if the field is not empty
            element.style.border = '';
          }

          // Add email validation
          if (element.type === 'email' && !isValidEmail(element.value)) {
            // Add a red border to indicate an invalid email
            element.style.border = '1px solid red';
            errorMessage = 'Email is not correct.';
            hasEmptyRequiredFields = true;
          }

          // Add number validation
            if (element.type === 'number') {
              const min = element.getAttribute('min');
              const max = element.getAttribute('max');
              
              if (!isValidNumber(element.value, min, max)) {
                // Add a red border to indicate an invalid number
                element.style.border = '1px solid red';
                
                if (element.value === '') {
                  errorMessage = 'Please fillup required field and maintain its format.';
                } else if (!(/^\d+$/.test(element.value))) {
                  errorMessage = 'Please enter a valid number (digits only).';
                } else if (min !== '' || max !== '') {
                  if (min !== '' && max !== '') {
                    errorMessage = `Number must be between ${min} and ${max}.`;
                  } else if (min !== '') {
                    errorMessage = `Number must be at least ${min}.`;
                  } else {
                    errorMessage = `Number must not exceed ${max}.`;
                  }
                }
                
                hasEmptyRequiredFields = true;
              }
            }

          //custom captch
          if (element.name.endsWith('_correct')) {
            const captchaFieldName = element.name.replace('_correct', '');
            const captchaUserAnswer = formDataObject[captchaFieldName];
            const captchaCorrectAnswer = element.value;
        
            if (captchaUserAnswer !== captchaCorrectAnswer) {
              // Display an error message for the custom captcha
              errorMessage = 'Wrong captcha, please fill in the correct answer.';
              hasEmptyRequiredFields = true;
            }
          }

          //Canvas to image create to store the image in databse as a link
          if (element.classList.contains('signature-data')) {
            var canvasId = element.dataset.canvasId;
            var signatureCanvas = document.getElementById(canvasId);
            // console.log(signatureCanvas);
            // Capture signature data as a base64-encoded PNG image
            var signatureData = signatureCanvas.toDataURL('image/png');
            // console.log(signatureData)
            formDataObject[element.name] = encodeURIComponent(signatureData); // it keep the + before sending to network
            // console.log(formDataObject[element.name]);
          }
        
      });

      
      // If there are empty required fields, prevent form submission
      if (hasEmptyRequiredFields || errorMessage) {
        submitButton.innerText = originalButtonText;
        // alert('Please fill out all required fields.');
        errorDiv.textContent = errorMessage || 'Please fill out all required fields.';
        return;
      }else{
         // Clear the error message if there are no errors
        errorDiv.textContent = '';
      }

      // Create an AJAX request for the form submission
      var xhr = new XMLHttpRequest();
      xhr.open('POST', front_end_data.admin_ajax, true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

      var data = "action=simpleform_get_submit_data" + "&nonce=" + encodeURIComponent(nonce) + "&id=" + encodeURIComponent(formId) + "&form_data=" + JSON.stringify(formDataObject) + "&current_page_url=" + encodeURIComponent(window.location.href);

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          
          // Set button text back to the original text
          submitButton.innerText = originalButtonText;

          if (xhr.status === 200) {
            var responseData = JSON.parse(xhr.responseText);

            // console.log('Response:', responseData);

             // Check if the form should be closed after submission
           
            var shouldCloseForm = formContainer.dataset.close === "true";
 
            if (responseData.success) {
              // Clear the form fields
              var form = formContainer.querySelector('.simple_form');
              form.reset();


              // Close the form if required
              if (shouldCloseForm) {
                formContent.classList.remove('active');
                formContent.style.height = '0';
              }
              

              //Rest captch and add new value 
              var captchaField = form.querySelector('[name^="custom-captcha-input"]');
              var captchaCorrectField = form.querySelector('[name^="custom-captcha-input-"][name$="_correct"]');
              // Generate a random operation and operands
              var captchaOperation = generateRandomOperation();
              // console.log(captchaOperation);
              // Update the UI with the new captcha operation
              var captchaSpan = form.querySelector('[class^="question-"]');

              if(captchaSpan){
                captchaSpan.textContent = `${captchaOperation.operand1} ${captchaOperation.operation} ${captchaOperation.operand2} =`;
                // Set the correct value
                captchaCorrectField.value = eval(`${captchaOperation.operand1} ${captchaOperation.operation} ${captchaOperation.operand2}`);
                // Clear the user's input
                captchaField.value = '';
              }
             
              
              /**
               * WhatsApp redirection
               */
              const scf_json = getCookie("simple_form_whatsapp_data");
              if(scf_json){
                const scf_opt = JSON.parse(scf_json);
              
                  if (scf_opt && scf_opt.simple_form_whatsapp_number) {
                    const newTab = scf_opt.simple_form_new_tab === "true";
                    const target = newTab ? "_blank" : "_self";
                    const number = scf_opt.simple_form_whatsapp_number;
                    
                    // Convert the simple_form_whatsapp_data object to a formatted string
                    const text = Object.keys(scf_opt.simple_form_whatsapp_data)
                      .map(key => `${key}: ${scf_opt.simple_form_whatsapp_data[key]}`)
                      .join("\n");

                    const mobileurl = `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
                    const weburl = `https://web.whatsapp.com/send?phone=${number}&text=${encodeURIComponent(text)}`;

                    const url = window.innerWidth > 1024 ? weburl : mobileurl;
                    window.open(url, target);

                    eraseCookie("simple_form_whatsapp_data");
                  }
                  // END 
              }
              
              showCustomModal(
                'Thanks for your submission', 
                'We will contact you soon <br> Have a nice day.',
                3000 // Duration in milliseconds (3 seconds)
              );
              
            } else{
              console.log(responseData.data.message); 
              errorDiv.textContent = "Don't try it again! You silly human!"
            }

          } else {
            // Handle the error for this form
            console.log('Form', formId, 'Error:', xhr.statusText);
          }
        }
      };

      xhr.send(data);
    });
  });
});


//after submit rest and add new vlaue to captch
function generateRandomOperation() {
  const operations = ['+', '-', '*'];
  // const operations = ['+', '-', '*', '/'];
  const operation = operations[Math.floor(Math.random() * operations.length)];

  let operand1, operand2;
  if (operation === '/') {
    operand2 = Math.floor(Math.random() * 9) + 1; // Ensure operand2 is not zero
    operand1 = operand2 * (Math.floor(Math.random() * 9) + 1);
  } else {
    operand1 = Math.floor(Math.random() * 10);
    operand2 = Math.floor(Math.random() * 10);
  }

  return { operation, operand1, operand2 };
}


// Helper function to validate email
function isValidEmail(email) {
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}

// Helper function to validate number
/* function isValidNumber(number) {
  var numberPattern = /^\d+$/;
  return numberPattern.test(number);
} */

function isValidNumber(value, min, max) {
  // First check if it matches your number pattern (digits only)
  var numberPattern = /^\d+$/;
  if (!numberPattern.test(value)) {
    return false;
  }
  
  // Convert to number for min/max comparison
  const numValue = parseFloat(value);
  
  // Check min constraint if present
  if (min !== undefined && min !== '' && numValue < parseFloat(min)) {
    return false;
  }
  
  // Check max constraint if present
  if (max !== undefined && max !== '' && numValue > parseFloat(max)) {
    return false;
  }
  
  return true;
}


function setCookie(name, value, days) {
  let expires = "";

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${name}=${value || ""}${expires}; path=/`;
}

function getCookie(name) {
  const cookieStr = decodeURIComponent(document.cookie);
  const cookies = cookieStr.split("; ");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];

    if (cookie.startsWith(`${name}=`)) {
      return cookie.substring(name.length + 1);
    }
  }
  return "";
}

function eraseCookie(name) {
  setCookie(name, "", -1);
}

// END ---------------------------------------------------


/**
 *  Floating form action 
 */
window.addEventListener('load', function () {
  // Get references to the WhatsApp icon and the form content
  const whatsappIcon = document.querySelector('.whatsapp-icon');
  const formContent = document.querySelector('.form-content');
  const closeButton = document.querySelector('.sf-close');
  const containerFloat = document.querySelector('.simple_form_container_floating');

  // Toggle the "active" class and adjust the height of the form content when the icon is clicked
  if(whatsappIcon){
    whatsappIcon.addEventListener('click', function () {
      formContent.classList.toggle('active');
      adjustFormHeight(formContent);
    });
  }

   // Close the form when the close button is clicked
   if (closeButton) {
    closeButton.addEventListener('click', function () {
      formContent.classList.remove('active');
      formContent.style.height = '0';
    });
  }

  // Check if the form should be initially open

  if(containerFloat){
    var OpenForm = containerFloat.dataset.open === "true";
    // console.log(containerFloat.dataset)
    if (OpenForm) {
        formContent.classList.add('active');
        adjustFormHeight(formContent);
    }
  }
  
  

  function adjustFormHeight(element) {
    const isActive = element.classList.contains('active');
    if (isActive) {
      // Calculate the full height of the form content
      // element.style.height = element.scrollHeight + 'px'; // prev used
      element.style.height = 'auto';
      element.style.maxHeight = '520px';

      if (containerFloat) {
        containerFloat.style.overflowY = 'auto';
        containerFloat.style.maxHeight = '465px';
      }

    } else {
      // Set the height back to 0 for collapsing effect
      element.style.height = '0';
    }
  }
  
});


// Function to restart the animation
function restartAnimation() {
  const whatsappIcon = document.getElementById('jumping-whatsapp');
  if(whatsappIcon){
    whatsappIcon.style.animation = 'none';
    // Trigger reflow
    void whatsappIcon.offsetWidth; 
    // Set animation duration to 5 seconds
    whatsappIcon.style.animation = 'jumpAnimation 0.9s ease-in-out'; 
  }
 
}

// Initially, trigger the animation 4-5 times with a delay
let initialAnimationCount = 0;
// Random value between 4 and 5
const maxInitialAnimationCount = Math.floor(Math.random() * 2) + 1; 

function initialAnimations() {
  if (initialAnimationCount < maxInitialAnimationCount) {
    restartAnimation();
    initialAnimationCount++;
    setTimeout(initialAnimations, 200); // Adjust the delay as needed
  }
}

// Start initial animations
initialAnimations();

// After the initial animations, continue with the 10-second animation cycle
setInterval(restartAnimation, 3000); // Restart every

// END 